import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\'info-with-side-details\' ...attributes>\n  {{yield (component \'ui/info-with-side-details/-item\')}}\n</div>")